import { useLocation } from 'react-router-dom';
import useAbilityPermissions from '../../hooks/useAbilityPermissions';
import NoPermissions from '../../pages/NoPermissions';

/**
 * Maps URL path prefixes to resource keys.
 * All routes within a prefix share the same resource permission.
 */
const ROUTE_RESOURCE_MAP = [
  { prefix: '/realtime/', resource: 'qm.reports.realtime' },
  { prefix: '/ticket-info/', resource: 'qm.reports.export' },
  { prefix: '/annual/', resource: 'qm.reports' },
  { prefix: '/monthly/', resource: 'qm.reports' },
  { prefix: '/weekly/', resource: 'qm.reports' },
  { prefix: '/daily/', resource: 'qm.reports' },
  { prefix: '/reports/', resource: 'qm.reports' },
];

/**
 * Wraps the entire route tree. Checks permission based on current URL prefix.
 * Dashboard (/) is allowed for anyone with qm.dashboard read access.
 */
const RouteGuard = ({ children }) => {
  const { can } = useAbilityPermissions();
  const { pathname } = useLocation();

  // Dashboard — always accessible if user has any QM permission
  if (pathname === '/') {
    if (can('read', 'qm.dashboard') || can('read', 'qm.reports')) {
      return children;
    }
    return <NoPermissions />;
  }

  // Match path prefix to resource
  const match = ROUTE_RESOURCE_MAP.find((r) => pathname.startsWith(r.prefix));
  if (match) {
    if (can('read', match.resource)) {
      return children;
    }
    return <NoPermissions />;
  }

  // Unknown route — allow (will hit catch-all redirect anyway)
  return children;
};

export { ROUTE_RESOURCE_MAP };
export default RouteGuard;
